import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { useVModel } from '@vueuse/core';
import { format, parseISO } from 'date-fns';
import { ru } from 'date-fns/locale';
import { isEqual, isNull } from 'lodash-es';
import { storeToRefs } from 'pinia';
import { BottomControlsButtons } from '~/core/components';
import BaseTextField from '~/core/components/Base/BaseTextField.vue';
import { rulesGenerators } from '~/core/utils/rulesGenerators';
import { SNACKBAR_MESSAGE as CORE_SNACKBAR } from '~/core/constants/snackbar';
import useMainSnackbarStore from '~/stores/useMainSnackbarStore';
import useMainDialogStore from '~/stores/useMainDialogStore';
import useMedcardDocumentsStore from '~/stores/useMedcardDocumentsStore';
import NewDocumentToFolderPopup from '~/features/Medcard/components/folders/NewDocumentToFolderPopup.vue';
import { MedcardDocumentType } from '~/features/Medcard/enums';
import { DIALOG_MESSAGE as MEDCARD_DIALOG } from '~/features/Medcard/constants/dialog';
import getDocumentGroupDate from '~/features/Medcard/functions/getDocumentGroupDate';
import { SNACKBAR_MESSAGE as MEDCARD_SNACKBAR } from '~/features/Medcard/constants/snackbar';
import { FoldersApi } from '~/features/Medcard/api/folders.api';
export default defineComponent({
  name: 'NewFolderPopup',
  components: {
    NewDocumentToFolderPopup: NewDocumentToFolderPopup,
    BaseTextField: BaseTextField,
    BottomControlsButtons: BottomControlsButtons
  },
  props: {
    value: {
      type: Boolean,
      default: true
    },
    foldersNames: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    folderToEdit: {
      type: Object,
      default: null
    }
  },
  emits: ['create', 'update:value', 'folder:created', 'folder:deleted'],
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var medcardDocumentsStore = useMedcardDocumentsStore();
    var _storeToRefs = storeToRefs(medcardDocumentsStore),
      medcardDocumentsCount = _storeToRefs.medcardDocumentsCount;
    var form = ref(null);
    var isFormCorrect = ref(false);
    var folderName = ref('');
    var initialFolderName = ref('');
    var isNewDocumentToFolderPopupActive = ref(false);
    var documentsToAdd = ref([]);
    var documentsToAddIds = ref([]);
    var initialDocumentsToAddIds = ref([]);
    var isExtraActionsBottomSheetActive = ref(false);
    var documentToRemoveIndex = ref(null);
    var isProcessing = ref(false);
    var isFetchDocuments = ref(false);
    var isActive = useVModel(props, 'value', emit);
    var _useNuxtApp = useNuxtApp(),
      $captureException = _useNuxtApp.$captureException;
    var $dialog = useMainDialogStore();
    var $snackbar = useMainSnackbarStore();
    var flatMedcardDocuments = computed(function () {
      return medcardDocumentsStore.medcardFlatDocuments;
    });
    var folderNameRules = computed(function () {
      return [rulesGenerators.required(), function (v) {
        var sameFolder = props.foldersNames.find(function (name) {
          return name.toLowerCase() === v.toLowerCase();
        });
        if (sameFolder && props.folderToEdit && sameFolder === props.folderToEdit.name) {
          return true;
        }
        return !sameFolder || 'Папка с таким названием уже есть';
      }];
    });
    var hasAnyChanges = computed(function () {
      return initialFolderName.value !== folderName.value || !isEqual(initialDocumentsToAddIds.value.sort(), _toConsumableArray(documentsToAddIds.value).sort());
    });
    var isSaveButtonDisabled = computed(function () {
      if (props.folderToEdit) {
        return !hasAnyChanges.value;
      }
      return !isFormCorrect.value;
    });
    watch(isActive, function (val) {
      var _props$folderToEdit, _props$folderToEdit2, _form$value;
      if (!val) {
        return;
      }
      folderName.value = ((_props$folderToEdit = props.folderToEdit) === null || _props$folderToEdit === void 0 ? void 0 : _props$folderToEdit.name) || '';
      initialFolderName.value = ((_props$folderToEdit2 = props.folderToEdit) === null || _props$folderToEdit2 === void 0 ? void 0 : _props$folderToEdit2.name) || '';
      (_form$value = form.value) === null || _form$value === void 0 ? void 0 : _form$value.resetValidation();
      documentsToAddIds.value = props.folderToEdit ? _toConsumableArray(props.folderToEdit.documentGroups) : [];
      initialDocumentsToAddIds.value = props.folderToEdit ? _toConsumableArray(props.folderToEdit.documentGroups) : [];
      documentsToAdd.value = props.folderToEdit ? getDocumentsByIds(props.folderToEdit.documentGroups) : [];
    }, {
      immediate: true
    });
    function getIcon(type) {
      switch (type) {
        case MedcardDocumentType.Analysis:
          return 'ui-icon-laba';
        case MedcardDocumentType.Conclusion:
          return 'ui-icon-data-graph';
        case MedcardDocumentType.Survey:
          return 'ui-icon-doctor';
        default:
          return 'ui-icon-note';
      }
    }
    function handleClickSubmit() {
      return _handleClickSubmit.apply(this, arguments);
    }
    function _handleClickSubmit() {
      _handleClickSubmit = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var payload;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(isSaveButtonDisabled.value || isProcessing.value)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              isProcessing.value = true;
              _context.prev = 3;
              payload = {
                name: folderName.value,
                documentGroupIds: documentsToAddIds.value
              };
              if (props.folderToEdit) {
                _context.next = 10;
                break;
              }
              _context.next = 8;
              return FoldersApi.createMedcardFolder(payload);
            case 8:
              _context.next = 12;
              break;
            case 10:
              _context.next = 12;
              return FoldersApi.updateMedcardFolder(props.folderToEdit.id, payload);
            case 12:
              $snackbar.open(props.folderToEdit ? MEDCARD_SNACKBAR.CHANGES_SAVED : MEDCARD_SNACKBAR.FOLDER_CREATED);
              emit('folder:created');
              isActive.value = false;
              _context.next = 21;
              break;
            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](3);
              $snackbar.open(CORE_SNACKBAR.TRY_AGAIN_ERROR);
              $captureException(_context.t0, {
                component: 'NewFolderPopup',
                method: 'handleClickSubmit'
              });
            case 21:
              _context.prev = 21;
              isProcessing.value = false;
              return _context.finish(21);
            case 24:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[3, 17, 21, 24]]);
      }));
      return _handleClickSubmit.apply(this, arguments);
    }
    function handleRemoveFromFolder() {
      return _handleRemoveFromFolder.apply(this, arguments);
    }
    function _handleRemoveFromFolder() {
      _handleRemoveFromFolder = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var isResolved;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              isExtraActionsBottomSheetActive.value = false;
              _context2.next = 3;
              return $dialog.open(MEDCARD_DIALOG.REMOVE_DOCUMENT_FROM_FOLDER);
            case 3:
              isResolved = _context2.sent;
              if (!(isResolved || isNull(documentToRemoveIndex.value))) {
                _context2.next = 6;
                break;
              }
              return _context2.abrupt("return");
            case 6:
              documentsToAddIds.value.splice(documentToRemoveIndex.value, 1);
              documentsToAdd.value.splice(documentToRemoveIndex.value, 1);
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return _handleRemoveFromFolder.apply(this, arguments);
    }
    function handleClickPrependIcon() {
      return _handleClickPrependIcon.apply(this, arguments);
    }
    function _handleClickPrependIcon() {
      _handleClickPrependIcon = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var isResolved;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (hasAnyChanges.value) {
                _context3.next = 3;
                break;
              }
              isActive.value = false;
              return _context3.abrupt("return");
            case 3:
              _context3.next = 5;
              return $dialog.open(MEDCARD_DIALOG.CANCEL_CHANGES);
            case 5:
              isResolved = _context3.sent;
              if (isResolved) {
                _context3.next = 8;
                break;
              }
              return _context3.abrupt("return");
            case 8:
              isActive.value = false;
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return _handleClickPrependIcon.apply(this, arguments);
    }
    function getDocumentsByIds(ids) {
      return flatMedcardDocuments.value.filter(function (item) {
        return ids.includes(item.id);
      }).map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          dtVisit: format(parseISO(getDocumentGroupDate(item)), 'd MMMM yyyy', {
            locale: ru
          })
        });
      });
    }
    function handleAddDocumentsToFolder(ids) {
      documentsToAddIds.value = ids;
      documentsToAdd.value = getDocumentsByIds(ids);
    }
    function handleDocumentItemActionClick(index) {
      isExtraActionsBottomSheetActive.value = true;
      documentToRemoveIndex.value = index;
    }
    function handleClickAddDocumentToFolder() {
      return _handleClickAddDocumentToFolder.apply(this, arguments);
    }
    function _handleClickAddDocumentToFolder() {
      _handleClickAddDocumentToFolder = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              isFetchDocuments.value = true;
              _context4.next = 4;
              return medcardDocumentsStore.fetchMedcardGroups({
                withError: true
              });
            case 4:
              if (isActive.value) {
                isNewDocumentToFolderPopupActive.value = true;
              }
              _context4.next = 11;
              break;
            case 7:
              _context4.prev = 7;
              _context4.t0 = _context4["catch"](0);
              $snackbar.open(CORE_SNACKBAR.TRY_AGAIN_ERROR);
              $captureException(_context4.t0, {
                component: 'NewFolderPopup',
                method: 'handleClickAddDocumentToFolder'
              });
            case 11:
              isFetchDocuments.value = false;
            case 12:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[0, 7]]);
      }));
      return _handleClickAddDocumentToFolder.apply(this, arguments);
    }
    function handleClickAppendIcon() {
      return _handleClickAppendIcon.apply(this, arguments);
    }
    function _handleClickAppendIcon() {
      _handleClickAppendIcon = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var isResolved;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return $dialog.open(MEDCARD_DIALOG.DELETE_FOLDER);
            case 2:
              isResolved = _context5.sent;
              if (!(isResolved || !props.folderToEdit)) {
                _context5.next = 5;
                break;
              }
              return _context5.abrupt("return");
            case 5:
              _context5.prev = 5;
              _context5.next = 8;
              return FoldersApi.deleteFolder(props.folderToEdit.id);
            case 8:
              emit('folder:deleted');
              isActive.value = false;
              _context5.next = 16;
              break;
            case 12:
              _context5.prev = 12;
              _context5.t0 = _context5["catch"](5);
              $snackbar.open(CORE_SNACKBAR.TRY_AGAIN_ERROR);
              $captureException(_context5.t0, {
                component: 'NewFolderPopup',
                method: 'handleClickAppendIcon'
              });
            case 16:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[5, 12]]);
      }));
      return _handleClickAppendIcon.apply(this, arguments);
    }
    return {
      isActive: isActive,
      form: form,
      isFormCorrect: isFormCorrect,
      folderName: folderName,
      isNewDocumentToFolderPopupActive: isNewDocumentToFolderPopupActive,
      documentsToAdd: documentsToAdd,
      documentsToAddIds: documentsToAddIds,
      isExtraActionsBottomSheetActive: isExtraActionsBottomSheetActive,
      flatMedcardDocuments: flatMedcardDocuments,
      medcardDocumentsCount: medcardDocumentsCount,
      isSaveButtonDisabled: isSaveButtonDisabled,
      isProcessing: isProcessing,
      isFetchDocuments: isFetchDocuments,
      rules: folderNameRules,
      handleClickSubmit: handleClickSubmit,
      getIcon: getIcon,
      handleRemoveFromFolder: handleRemoveFromFolder,
      handleClickPrependIcon: handleClickPrependIcon,
      handleAddDocumentsToFolder: handleAddDocumentsToFolder,
      handleDocumentItemActionClick: handleDocumentItemActionClick,
      handleClickAddDocumentToFolder: handleClickAddDocumentToFolder,
      handleClickAppendIcon: handleClickAppendIcon
    };
  }
});